import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ClaroTooltip } from "@claropay/shared";
import * as sdkclaro from "@claropay/claro-pay-sdk-v2";
import { executeTaggeo, getAmountOfTelcelPospago, getCommissionInfo, getPaymentMethods, setCreditCardInfo } from '../../../store/actions';
import { formatCurrency, validateUserAgent } from '../../organisms/utils';
import { selectPaymentServiceConf } from '../../../store/selectors/paymentsSelectors';
import SelectInputTelcelContainer from '../../organisms/inputsClaroSocio/SelectInputTelcelContainer';
import { ADVANCEMENT_CLARO_PAY, CREDIT_CLARO_PAY, OFFER_TELCEL_POSPAGO, SERVICE_ID_TELCEL_POSPAGO } from '../../../constants';
import CvvInputTelcelContainer from '../../organisms/inputsClaroSocio/CvvInputTelcelContainer';
import SelectCardClaroSocio from '../../organisms/inputsClaroSocio/SelectCardClaroSocio';

const Container = styled.div`
	padding: 0px 16px;
`;

const Title = styled.p`	
	margin: 0px;
	padding: 18px 16px 16px 16px;
	text-align: center;
`;

const TitleText = styled.span`
	color: #222222;
	font-family: AMX-Regular;
	font-size: 14px;
`;

const TitleLine = styled.span`
	color: #222222;
	font-family: AMX-Bold;
	font-size: 14px;
`;

const MainCard = styled.div`
	background: #ffffff;
	border-radius: 8px;
	box-shadow: 0px 1.9px 1.9px 0px rgba(0,0,0,0.24), 0px 1.9px 1.9px 0px rgba(0,0,0,0.12);
	padding: 16px 13px;
`;


const SectionAmountAndPay = styled.div`
	align-items: center;
	column-gap: 5px;
	display: grid;
	grid-template-columns: auto auto;
	margin-bottom: ${props => props.isFluxAnonimous ? "0px" : "15px"};
`;

const AmountText = styled.span`
	color: #222222;
	font-family: AMX-Regular;
	font-size: 14px;
	margin-right: 5px;
`;

const AmountTotal = styled.span`
	color: #008000;
	font-family: AMX-Bold;
	font-size: 18px;
	position: relative;
	top: 2px;
`;

const ButtonPay = styled.button`
	background: ${props => props.active ? "#7b1fa2" : "#d0d0d0"};
	border: 0px;
	border-radius: 18px;
	color: ${props => props.active ? "#ffffff" : "#595959"};
	font-family: AMX-Bold;
	font-size: 16px;
	margin: 0px 0px 0px auto;
	max-width: 117px;
	padding: 9px 38px 7px 38px;
`;

const Divider = styled.hr`
	border: 0px;
	border-top: 1px solid #bac9d8;
	margin-bottom: ${props => props.marginBottom ? props.marginBottom : "5px"}
`;

const PospagoSectionPay = ({
	getAmountOfTelcelPospago,
	amountTelcelPospago,
	userInfo,
	paymentsConfig,
	isAnonimous,
	creditCardInfo,
	setCreditCardInfo,
	paymentMethods,
	getPaymentMethods,
	isLoadingGetPaymentMethods,
	isClaroPartner,
	isContainerTelcel,
	executeTaggeo,
	getCommissionInfo,
	trackId,
	history,
	commissionRules
}) => {
	const [lineNumber, setLineNumber] = React.useState("");
	const [showCvvField, setShowCvvField] = React.useState(false);
	const [cvvInput, setCvvInput] = React.useState();
	const [cvvValue, setCvvValue] = React.useState("");
	const [activeSubmit, setActiveSubmit] = React.useState(false);
	const [selectProps, setSelectProps] = React.useState({});
	const [isFluxAnonimous, setIsFluxAnonimous] = React.useState(false);
	const [isOpenToolTip, setIsOpenTooltip] = React.useState(false);
	const [isOpenSelect, setIsOpenSelect] = React.useState(false);
	const [isOpenSelectAnonimous, setIsOpenSelectAnonimous] = React.useState(false);

	React.useEffect(() => {
		// MSISDN only for title
		const msisdn = !isAnonimous
			? userInfo.msisdn
			: (paymentsConfig.msisdn ? paymentsConfig.msisdn : "");
		setLineNumber(msisdn.slice(-10));

		// Get amount telcel
		if (userInfo.isTelcel === true || userInfo.isTelcel === "true") {
			getAmountOfTelcelPospago(
				msisdn.slice(-10),
				SERVICE_ID_TELCEL_POSPAGO
			);
		}	

		// Prop for input field
		const serviceConfig = paymentsConfig.services[OFFER_TELCEL_POSPAGO];
		const inputCvv = serviceConfig.serviceData.generic.elements.find(element => element.id === "cvv");
		setCvvInput(inputCvv);		
	}, []);

	React.useEffect(() => {
		if (
			paymentMethods &&
			amountTelcelPospago &&
			amountTelcelPospago.pendingAmount &&
			(paymentMethods.hasN2 || paymentMethods.cardList.length > 0)
		) { setDefaultPaymentMethod() }
	}, [
		amountTelcelPospago
	]);

	// Set flux
	React.useEffect(() => {
		setIsFluxAnonimous(
			isAnonimous || 
			(
				paymentMethods && 
				!paymentMethods.hasN2 && 
				paymentMethods.cardList.length === 0
			) ? true : false
		)
	}, [isAnonimous]);

	React.useEffect(() => {
		setActiveSubmit(isFluxAnonimous ? true : activeSubmit);
	}, [isFluxAnonimous]);

	React.useEffect(() => {
		setShowCvvField(
			commissionRules &&
			commissionRules[0] 
				? commissionRules[0].payProcessor.showCVV 
				: false
		);

		if (
			(
				creditCardInfo &&
				creditCardInfo.value && 
				(
					creditCardInfo.value === "claro-pay" || 
					creditCardInfo.value === CREDIT_CLARO_PAY || 
					creditCardInfo.value === ADVANCEMENT_CLARO_PAY
				)
			) ||
			isFluxAnonimous
		) {
			setActiveSubmit(true);
		} else {
			setActiveSubmit(
				commissionRules &&
				commissionRules[0] &&
				creditCardInfo && 
				creditCardInfo.value && 
				cvvValue.length === 3
			);
		}
	}, [creditCardInfo, commissionRules, cvvValue])

	const setDefaultPaymentMethod = () => {
		let cardInfo = {};
		let defaultItemPaymentMethod = [];
		if (creditCardInfo && creditCardInfo.value != "agregar-targeta" && creditCardInfo.value != undefined) {
            cardInfo = creditCardInfo;
		} else {
			defaultItemPaymentMethod = paymentMethods.cardList.filter(
				(item) => item.isDefault != "0"
			);
			if (paymentMethods.hasN2) {
				if (defaultItemPaymentMethod[0]) {				
					cardInfo = {
						value: defaultItemPaymentMethod[0].cardId,
						mark: defaultItemPaymentMethod[0].card.mark,
						type: defaultItemPaymentMethod[0].card.type,
						lastDigits: defaultItemPaymentMethod[0].card.lastDigits,
						update: false,
					};
				} else {
					cardInfo = {
						value: "claro-pay",
						mark: "999",
						type: 0,
						lastDigits: " ",
						update: false,
					};
				}
			} else {
				if (defaultItemPaymentMethod[0]) {
					cardInfo = {
						value: defaultItemPaymentMethod[0].cardId,
						mark: defaultItemPaymentMethod[0].card.mark,
						type: defaultItemPaymentMethod[0].card.type,
						lastDigits: defaultItemPaymentMethod[0].card.lastDigits,
						update: false,
					};
				} else {
					cardInfo = {
						value: paymentMethods.cardList[0].cardId,
						mark: paymentMethods.cardList[0].card.mark,
						type: paymentMethods.cardList[0].card.type,
						lastDigits: paymentMethods.cardList[0].card.lastDigits,
						update: false,
					};
				}
			}
		}
		handleInputClick(event, "cardId", cardInfo);		
	};

	const handleInputClick = (event, typeInput, cardInfo) => {
		const { sdkClaroVersion } = paymentsConfig;
		setCreditCardInfo(cardInfo);
		setIsOpenSelect(false);
		setCvvValue("");
		if (cardInfo.value == "agregar-targeta") {
			setSelectProps({
				value: "",
				valueCardId: "",
				mark: "",
			});
			sdkclaro.getInstance().openWallet("openWallet");
		} else {
			setSelectProps({
				value: cardInfo.lastDigits,
				valueCardId: cardInfo.value,
				mark: cardInfo.mark,
				handleInputButtonFunction: handleClickSelect
			})
			if (cardInfo.value === CREDIT_CLARO_PAY) {
				setCvvValue("");
			} else {
				const isClaroPay = cardInfo.value === "claro-pay" ? true : false;
				const amount = amountTelcelPospago.pendingAmount || 1
				getCommissionInfo(
				    SERVICE_ID_TELCEL_POSPAGO,
				    "",
				    amount,
				    isClaroPay,
				    cardInfo.value,
				    sdkClaroVersion,
				    false,
				    trackId
				);
			}
		}
	};

	const handleInputChange = (e) => {
		let value = e.target.value;
		const numericValue = value.replace(/\D/g, '');
		if (numericValue.length <= 3) {
			setCvvValue(numericValue);
		}
	}

	const handleClickTooltip = (e, modal) => {
		setIsOpenTooltip(true);
	}

	const handleClickSelect = () => {
        if (!isFluxAnonimous) {
            getPaymentMethods(SERVICE_ID_TELCEL_POSPAGO, false);
			setIsOpenSelect(true);
        } else {
            setIsOpenSelectAnonimous(true);
        }        
    }

	const redirect = () => {
		const { sdkClaroVersion, tagServiceId } = paymentsConfig;
        const showCVV = commissionRules && commissionRules[0] ? commissionRules[0].payProcessor.showCVV : false;
        history.push({
			pathname: '/menuTelcel',
			state: {
				paymentMethods,
				isContainerTelcel: isContainerTelcel,
				sdkVersion: sdkClaroVersion,
				paymentsConfig: paymentsConfig,
				isClaroPartner: isClaroPartner,
				serviceConfigIndex: OFFER_TELCEL_POSPAGO,
				tagServiceId: tagServiceId,
				paramsNewOfferTelcel: {
					line: lineNumber,
					creditCardInfo: creditCardInfo,
					cvv: { cvvValue: cvvValue, isRequiredCvv: showCVV }
				}
			}
		})
    }

	return (
		<>
			{
				cvvInput &&
				amountTelcelPospago &&
				amountTelcelPospago.responseCode === 0 &&
				(userInfo.isTelcel === true || userInfo.isTelcel === "true") &&
				<>
					<Container>
						<Title>
							<TitleText>Tu número celular es:&nbsp;</TitleText>
							<TitleLine>{lineNumber}</TitleLine>
						</Title>
						<MainCard>
							<SectionAmountAndPay isFluxAnonimous={isFluxAnonimous} >
								<span>
									<AmountText>Total a pagar:</AmountText>
									<AmountTotal>
										${parseFloat(amountTelcelPospago.pendingAmount).toFixed(2)}
									</AmountTotal>
								</span>
								<ButtonPay active={activeSubmit} onClick={redirect}>
									Pagar
								</ButtonPay>
							</SectionAmountAndPay>
							{
								!isFluxAnonimous ?
								<>
									<Divider />
									<SelectInputTelcelContainer {...selectProps} />
									{
										showCvvField &&
										<>
											<Divider />
											<CvvInputTelcelContainer
												input={cvvInput}
												isValid={cvvValue.length === 3}
												value={cvvValue}
												visible={showCvvField}
												handleClickTooltip={handleClickTooltip}
												handleInputChange={handleInputChange} />
										</>								
									}
								</>
								:
								<>
								
								</>
							}						
						</MainCard>
					</Container>
					<ClaroTooltip
						closeImg={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}icono_salir_contenedor.png`}
						fontFamilyTitle={"AMX-Bold"}
						fontFamilySubtitle={"AMX-Regular"}
						isOpen={isOpenToolTip}
						addCloseEfect={false}
						onclickCloseTooltip={() => setIsOpenTooltip(false)}
						text={"Tarjeta Visa y Master Card"}
						srcImage={"/images/cvv.png"}
						heightImg={validateUserAgent() === "android" ? "43%" : "38%"}
						colorButton="#797878"
						fontSizeTitle={"18"}
						height={"58%"}
						colorTitle={"#000000"}
						fontSizeButton="23px!important"
						fadeInTime="1s"
						fadeIn
						cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
						widthImg="272px"
						textSubtitle={"El número de tres dígitos ubicado en el reverso de tu tarjeta de crédito o débito."}
						colorSubtitle={"#000000"}
						fontWeightTitle="bold!important"
						fontWeightSubtitle="normal!important"
						fontSizeSubtitle="12px"
						paddingTitle="3px 16px 0px 16px"
						marginTitle={"0px 0px 15px 0px"}
						marginButton="0px 0px 0px 0px"
						boxShadow="none"
					/>
					<SelectCardClaroSocio
						backgroundColor="rgba(0,0,0,0.8)"
						isOpen={!isLoadingGetPaymentMethods && isOpenSelect}
						colorButton="#797878"
						height="70%"
						marginButton="0px 0px 0px 10px"
						fontSizeButton="23px!important"
						fadeInTime="1s"
						cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
						fadeIn
						addCloseEfect={false}
						cardItems={paymentMethods && paymentMethods.cardList ? paymentMethods.cardList : []}
						hasN2={paymentMethods && paymentMethods.hasN2 ? paymentMethods.hasN2 : false}
						closeSelectCardClaroSocio={() => setIsOpenSelect(false)}
						handleInputClick={handleInputClick}
						selectValue={selectProps.valueCardId}
						activeN2={true}
						isContainerTelcel={isContainerTelcel}
						executeTaggeo={executeTaggeo}
					/>
				</>
			}
		</>
	)
}

const mapStateToProps = (state) => {
	const { payments } = state;
	const amountTelcelPospago = payments.amountTelcelPospago;
	const isAnonimous = payments.isAnonimous;
	const paymentsConfig = selectPaymentServiceConf(payments);
	const userInfo = payments.userInfo;
	const cardInfo = payments.cardInfo;
	const trackId = payments.trackId;
	const paymentMethods = payments.paymentMethods;
	const isLoadingGetPaymentMethods = payments.isLoadingGetPaymentMethods;
	const isClaroPartner = payments.isClaroPartner;
	const isContainerTelcel = payments.isContainerTelcel;
	const commissionRules = payments.commissionRules;
	return {
		amountTelcelPospago,
		isAnonimous,
		paymentsConfig,
		userInfo,
		creditCardInfo: cardInfo,
		trackId,
		paymentMethods,
		isClaroPartner,
		isContainerTelcel,
		isLoadingGetPaymentMethods,
		commissionRules
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			getAmountOfTelcelPospago,
			setCreditCardInfo,
			getPaymentMethods,
			executeTaggeo,
			getCommissionInfo
		},
		dispatch,
	);
}

export default connect(mapStateToProps, mapDispatchToProps)(PospagoSectionPay);